<template>
  <v-container id="cargo-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <base-material-card class="small-icon" color="primary">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{ $i18n.t("View APILog") }}</div>
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="12">
                  <span>
                    <b>{{ $i18n.t("API Name") }}:</b>
                  </span>
                  <span class="ml-2">{{ apiLog.apiName }}</span>
                </v-col>
                <v-col cols="12" md="12">
                  <span>
                    <b>{{ $i18n.t("Phone") }}:</b>
                  </span>
                  <span class="ml-2">{{ apiLog.phone }}</span>
                </v-col>
                <v-col cols="12" md="12">
                  <span>
                    <b>{{ $i18n.t("Query Params") }}:</b>
                  </span>
                  <span class="ml-2">{{ apiLog.queryParams }}</span>
                </v-col>
                <v-col cols="12" md="12">
                  <span>
                    <b>{{ $i18n.t("Payload") }}:</b>
                  </span>
                  <span class="ml-2">{{ apiLog.payload }}</span>
                </v-col>
                <v-col cols="12" md="12">
                  <span>
                    <b>{{ $i18n.t("Result") }}:</b>
                  </span>
                  <span class="ml-2">{{ apiLog.result }}</span>
                </v-col>
                <v-col cols="12" md="12">
                  <span>
                    <b>{{ $i18n.t("Trait") }}:</b>
                  </span>
                  <span class="ml-2">{{ apiLog.tarit }}</span>
                </v-col>
                <v-col cols="12" md="12">
                  <span>
                    <b>{{ $i18n.t("Time") }}:</b>
                  </span>
                  <span>{{ apiLog.at | moment("DD MMM YYYY hh:mm a") }}</span>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>-->
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  apiLog = {};
  id = null;
  get loading() {
    return common.loading;
  }

  async get(id) {
    try {
      this.apiLog = await doGet("/api/apiLog/" + id + "/detail");
      this.id = this.apiLog._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
